<template>
  <FormItem :label="model.variable.label" :inline="inline">
    <Input type="text" v-model="model.val">
      <span slot="append" v-if="model.variable.unit"><strong>{{ model.variable.unit }}</strong></span>
    </Input>
  </FormItem>
</template>

<script>
export default {
  name: 'text-element',
  data: function () {
    return {
      newVal: this.model.val
    }
  },
  // watch: {
  //   'val': function () {
  //     this.newVal = this.val.val
  //   }
  // },
  props: ['model', 'inline'],
  methods: {
    editVal: function () {
      this.$emit('editVal', this.model, this.newVal)
    }
  }
}
</script>
